<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" class="filter-item" :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table
          style="height:calc(100% - 60px)"
          ref="mainTable"
          :select-type="'checkbox'"
          :table-fields="headerList"
          :data="list"
          :templates="['logPath']"
          :v-loading="listLoading"
        ></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import * as appLogs from '@/api/appLogs'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import extend from '@/extensions/common.js'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import Vue from 'vue'
export default {
  name: 'appLog',
  components: { Sticky, Pagination, AuthTable, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
      },
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('id', 'Id', false, false, '', '', 'bigint', 'bigint', 'Id'),
      new ColumnDefine('account', '账号', true, true, 'text', '', 'string', 'varchar', 'Account'),
      new ColumnDefine('app', 'App', true, true, 'text', '', 'string', 'varchar', 'App'),
      new ColumnDefine('appType', 'App类型', true, true, 'text', '', 'string', 'varchar', 'AppType'),
      new ColumnDefine('appVer', 'App版本', true, true, 'text', '', 'string', 'varchar', 'AppVer'),
      new ColumnDefine('sdkVer', 'SDK版本', true, true, 'text', '', 'string', 'varchar', 'SdkVer'),
      new ColumnDefine('device', '设备', true, true, 'text', '', 'string', 'varchar', 'Device'),
      new ColumnDefine('logTime', '时间', true, true, 'datetime', '', 'DateTime', 'datetime', 'LogTime'),
      new ColumnDefine('logPath', 'Url', true, true, 'text', '', 'string', 'varchar', 'LogPath'),
    ]
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      Vue.component('logPath', {
        props: ['row'],
        template: `<div style="text-align:center;width:100%;padding:auto 10px;"><a target="_blank" :href="row['logPath']">查看</a></div>`
      })


      appLogs.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
